var map = {
	"./dr-manjunath-new.jpg": 75723,
	"./dr-manjunath-new2.jpg": 75129,
	"./drmanjunath.jpg": 21666,
	"./drmanjunath11.jpg": 26663,
	"./drmanjunath12.jpg": 24356,
	"./javgal-s-suraj.jpg": 84862,
	"./praveen-k-john.jpg": 49423,
	"./ramapriyya-kalkunte.jpg": 16312,
	"./shekar-subbaiah-new.jpeg": 31255,
	"./shekhar-subbaiah.jpg": 38555,
	"./shekhar-subbaiah1.jpg": 12302
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 31706;